import React from "react";
import "./Track.scss";
import Point from "./Point/Point";
import { getShipmentStateIndex } from "../../utils/utils";

const Track = ({shipment, allowPick = true, allowDrop = true, allowDimmed = true}) => {
  let dimmedValue = allowDimmed ? "dimmed" : ""
  let showPick = allowPick ? shipment.pick.name : null
  let showPol = shipment.pol.name
  let showPod = shipment.pod.name
  let showDropoff = allowDrop ? shipment.dropoff.name : null
  let stopsCount = 2
  if (showPick || showPod) stopsCount = 3
  if (showPick && showPod && showDropoff) stopsCount = 4

  let state = getShipmentStateIndex(shipment.state);

  const landClassName = stopsCount == 4 ? 'land-small' : 'land'
  const seaClassName = stopsCount == 4 ? 'sea-small' : 'sea'

  const numberPoints = [showPick, showPol, showPod, showDropoff].map((f) => Number(f?.length > 0)).reduce((acc, val) => acc + val, 0)

  return (
    <div className="Track">
      {showPick && (
        <>
          <Point location={shipment.pick} className={`${state >= 3 ? "" : dimmedValue} num-points__${numberPoints}`} />
          <div className={state >= 4 ? "route-wrapper" : `route-wrapper ${dimmedValue}`}><div className={landClassName}><span>&nbsp;</span></div></div>
        </>
      )}

      {
        showPol && (
          <Point location={shipment.pol} className={`${state >= 5 ? "" : dimmedValue} num-points__${numberPoints}`} />
        )
      }

      {showPod && (
        <>
          <div className={state >= 6 ? "route-wrapper" : `route-wrapper ${dimmedValue}`}><div className={seaClassName}><span>&nbsp;</span></div></div>
          <Point location={shipment.pod} className={`${state >= 7 ? "" : dimmedValue} num-points__${numberPoints}`} />
        </>
      )}

      {showDropoff && (
        <>
          <div className={state > 7 ? "route-wrapper" : `route-wrapper ${dimmedValue}`}><div className={landClassName}><span>&nbsp;</span></div></div>
          <Point location={shipment.dropoff} className={`${state >= 7 ? "" : dimmedValue} num-points__${numberPoints}`} />
        </>
      )}
    </div>
  )
}

export default Track;